/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize GeneralSocial Risk Register View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './GeneralSocialRiskRegisterView';

export const mapStateToPropsGeneralSocialRiskRegister = mapStateToProps;
export const mapDispatchToPropsGeneralSocialRiskRegister = mapDispatchToProps;

export default connect(
  mapStateToPropsGeneralSocialRiskRegister,
  mapDispatchToPropsGeneralSocialRiskRegister
)(View);
